module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921025334_T.048c056b.jpg";